export const FORM_FIELDS = {
  name: 'Name',
  email: 'E-Mail',
  phone: 'Phone Number',
  service: 'Select related service',
  other: 'Other',
  message: 'Your Message Here',
  submit: 'Submit Now',
};

export const CONTACT_LABELS = {
  officeTitle: 'Al Khobar Office',
  officeAddress: 'Office address',
  openingHours: 'Opening Hours',
  emailUs: 'Email us',
  callUs: 'Call us',
  letsTalk: 'Lets talk',
  projectQuestion: 'Have an upcoming project?',
  workWithUs: 'Work With Us !',
  getStarted: 'Get Started',
  contactNow: 'Contact Now',
  readMore: 'Read More',
  getInTouch: 'Get In Touch',
  knowMore: 'Know more',
};

export const BREADCRUMBS = {
  home: 'Home',
  about: 'About',
  gallery: 'Gallery',
  services: 'Services',
  projects: 'Projects',
  blog: 'Blog',
  contact: 'Contact Us',
};
